import React from 'react';
import {Table} from 'semantic-ui-react';
import styled from 'styled-components';
import StatusBadge from './StatusBadge';
import FileActionButtons from './FileActionButtons';
import FileNameLink from './FileNameLink';
import EmptyState from './EmptyState';

const StyledTableWrapper = styled.div`
    padding: 0 27px;
`;

const MassUploadTable = ({files, onEdit, onView, onDelete, onDownload, formatDate}) => {
    if (files.length === 0) {
        return (
            <StyledTableWrapper>
                <EmptyState
                    message="Файлы не найдены."
                    suggestion="Попробуйте изменить параметры поиска или загрузите новый файл."
                />
            </StyledTableWrapper>
        );
    }

    return (
        <StyledTableWrapper>
            <Table className="ui table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>№ МЗ</Table.HeaderCell>
                        <Table.HeaderCell>Дата загрузки файла</Table.HeaderCell>
                        <Table.HeaderCell>Название файла</Table.HeaderCell>
                        <Table.HeaderCell>Автор</Table.HeaderCell>
                        <Table.HeaderCell>Ошибки</Table.HeaderCell>
                        <Table.HeaderCell>Статус</Table.HeaderCell>
                        <Table.HeaderCell>Дата и время операции</Table.HeaderCell>
                        <Table.HeaderCell>Действия</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {files.map(file => (
                        <Table.Row key={file.id}>
                            <Table.Cell>{file.id}</Table.Cell>
                            <Table.Cell>{formatDate(file.uploadDate)}</Table.Cell>
                            <Table.Cell>
                                <FileNameLink
                                    fileName={file.originalFileName}
                                    status={file.status}
                                    onClick={() => onEdit(file.id)}
                                    fileId={file.id}
                                />
                            </Table.Cell>
                            <Table.Cell>{file.authorName || '-'}</Table.Cell>
                            <Table.Cell className="text-danger">{file.errorRows}</Table.Cell>
                            <Table.Cell>
                                <StatusBadge status={file.status} />
                            </Table.Cell>
                            <Table.Cell>
                                {file.status === 'ParcelsCreated' && file.parcelsCreatedDate &&
                                    formatDate(file.parcelsCreatedDate)
                                }
                            </Table.Cell>
                            <Table.Cell>
                                <FileActionButtons
                                    file={file}
                                    onEdit={onEdit}
                                    onView={onView}
                                    onDelete={onDelete}
                                    onDownload={onDownload}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </StyledTableWrapper>
    );
};

export default MassUploadTable;




// WEBPACK FOOTER //
// ./App/pages/massUpload/components/MassUploadTable.jsx